import { useEffect, useState } from 'react';
import { logmarData, logmarToSnellen } from '../../helpers/data';
import { useTestContext } from '../../context/testContext';
import { useMaxLogmar } from '../../helpers/useMaxLogmar';
import { PanelTitle, SessionActions, useAutoHideVideo } from '../../ui';
import { ExamBody } from './exams/common';
import { StartSizeList } from './exams/StartSizeList';

// Step 2 "Please select a starting logMAR" (Figma session/10 middle). The video strip is hidden
// while this step is open. Logic unchanged: the chosen logmarData row is stored as testData[eye].
const SelectLogmar = ({ eyeTested, displayCharacters, updateStep }) => {
  const { testData, updateTestData, logmarCharacters, generateLogmarCharacters } = useTestContext();
  const [canProgress, setCanProgress] = useState(false);
  const updateMaxLogmar = useMaxLogmar();
  useAutoHideVideo();

  useEffect(() => {
    updateTestData({ [eyeTested]: null });
  }, [eyeTested, updateTestData]);

  useEffect(() => {
    updateMaxLogmar();
  }, [updateMaxLogmar]);

  useEffect(() => {
    if (displayCharacters) generateLogmarCharacters();
  }, [displayCharacters, generateLogmarCharacters]);

  useEffect(() => {
    if (testData[eyeTested]) {
      setCanProgress(true);
    } else setCanProgress(false);
  }, [testData, eyeTested]);

  const rows = logmarData
    .filter((l) => l?.id >= testData.maxPermittedLogmar.id)
    .map((logmar) => ({
      id: logmar.id,
      logmar,
      cells: [
        logmar.value.toFixed(1),
        logmarToSnellen[logmar.value.toFixed(1)],
        ...(displayCharacters ? [logmarCharacters?.[logmar.id] || ''] : []),
      ],
    }));

  return (
    <ExamBody style={{ gap: 16 }}>
      <PanelTitle small>Please select a starting logMAR</PanelTitle>
      <StartSizeList
        label='Starting logMAR'
        header={displayCharacters ? ['logMAR', 'Snellen', 'Characters'] : ['logMAR', 'Snellen']}
        cols={displayCharacters ? '0.7fr 0.7fr 2fr' : '1fr 1fr'}
        mutedFrom={1}
        charsCol={displayCharacters ? 2 : -1}
        rows={rows}
        selectedId={testData[eyeTested]?.id}
        onSelect={(row) => updateTestData({ [eyeTested]: row.logmar })}
      />
      <SessionActions onBack={() => updateStep('eyeSetup')} primary={{ label: 'Next', onClick: () => updateStep(`${eyeTested}Test`), disabled: !canProgress }} />
    </ExamBody>
  );
};

export default SelectLogmar;
